export default [
  {
    path: '/admin/greeting',
    name: 'greetingAdmin',
    meta: { title: 'greetingAdmin' },
    component: () => import('@/pages/admin/greeting'),
  },
]
